import type { UploadedSharedFile } from 'utils/uploadedSharedFile'

// One-shot content seeds for a freshly opened new-thread composer (share/clip
// flow). The share handler stashes shared content here under the draft quest id;
// the title composer consumes it on mount and runs it through its normal
// pipelines — the editor for text, the attachment pipeline for files — exactly
// as if the user had typed/picked it.
export type ComposerSeed = {
    // Quill Delta document to load into the title editor.
    deltaJson?: { ops: Array<Record<string, unknown>> }
    files?: File[]
    uploadedFiles?: UploadedSharedFile[]
}

const pendingSeedsByQuestId = new Map<string, ComposerSeed>()

export function setPendingComposerSeed(questId: string, seed: ComposerSeed) {
    if (
        !questId ||
        !seed ||
        (!seed.deltaJson && !seed.files?.length && !seed.uploadedFiles?.length)
    )
        return
    pendingSeedsByQuestId.set(String(questId), seed)
}

export function takePendingComposerSeed(questId: string | null | undefined): ComposerSeed | null {
    if (!questId) return null
    const seed = pendingSeedsByQuestId.get(String(questId))
    if (!seed) return null
    pendingSeedsByQuestId.delete(String(questId))
    return seed
}
